Wee.fn.make('flash', {
	/**
	 * Insert flash message into the DOM
	 *
	 * @param {object} options
	 * @param {object} [options.model={}]
	 * @param {string} [options.selector=ref:flash]
	 * @param {string} [options.view=flash.flash]
	 * @param {string} [options.namespace=flash]
	 * @param {string} [options.appendSelector=main]
	 * @param {string} [options.closeSelector=ref:flashClose]
	 * @param {(Array|function|string)} [options.onInsert]
	 * @param {number|boolean} [options.delay=4000]
	 */
	init: function(options) {
		var scope = this,
			settings = $.extend({
				model: {},
				selector: 'ref:flash',
				view: 'flash.flash',
				namespace: 'flash',
				appendSelector: 'main',
				closeSelector: 'ref:flashClose',
				delay: 4000
			}, options),
			selector = settings.selector,
			namespace = settings.namespace,
			onInsert = settings.onInsert,
			delay = settings.delay,
			$flash = $(selector);

		if (delay) {
			clearTimeout(this.timer);
		}

		if ($flash.length) {
			scope.destroy();
		}

		$(settings.appendSelector).append($.view.render(settings.view, settings.model));

		$.setRef();

		// Redefine new flash selector
		$flash = $(selector);

		if (onInsert) {
			onInsert();
		}

		$flash.find('a')
			.on('click', function(e, el) {
				$.history.go({
					path: $(el).attr('href')
				});

				e.preventDefault();
			}, {
				namespace: namespace
			});

		$(settings.closeSelector).on('click', function() {
			scope.destroy();
		}, {
			namespace: namespace
		});

		if (delay) {
			this.timer = setTimeout(function() {
				scope.destroy();
			}, delay);
		}
	},

	/**
	 * Destroy flash message
	 *
	 * @param {object} options
	 * @param {string} [options.selector=ref:flash]
	 */
	destroy: function(options) {
		var settings = $.extend({
				selector: 'ref:flash',
				namespace: 'flash'
			}, options),
			$flash = $(settings.selector);

		if ($flash.length) {
			$flash.remove();
		}

		$.events.off(false, '.' + settings.namespace);
	}
});